// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    background-color: #333;
    padding: 1rem 0;
    position: sticky;
    top: 0;
    z-index: 10;
}

.navbar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}

.navbar-logo {
    color: #fff;
    font-size: 1.5rem;
    text-decoration: none;
    font-weight: bold;
    font-family: "Rigidica Text Bold", sans-serif;
}

.navbar-menu {
    display: flex;
    list-style-type: none;
    margin: 0;
    padding: 0;
}

.navbar-item {
    color: #fff;
    text-decoration: none;
    padding: 0.5rem 1rem;
    font-family: "Rigidica Text Regular", sans-serif;
}

.navbar-item:hover {
    background-color: #444;
}

.navbar-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    opacity: 0;
    transition: opacity 0.3s ease;
    z-index: 5;
    pointer-events: none;
}

.navbar-backdrop.active {
    opacity: 1;
    pointer-events: auto;
}

.menu-icon {
    cursor: pointer;
    display: none;
    flex-direction: column;
    justify-content: space-between;
    width: 30px;
    height: 21px;
    position: relative;
    transition: all 0.3s ease-in-out;
}

.menu-icon-bar {
    height: 2px;
    width: 100%;
    background-color: #fff;
    border-radius: 2px;
    transition: all 0.3s ease-in-out;
    transform-origin: center;
}

.menu-icon.open .menu-icon-bar:nth-child(1) {
    transform: translateY(9.5px) rotate(45deg);
}

.menu-icon.open .menu-icon-bar:nth-child(2) {
    opacity: 0;
    transform: scaleX(0);
}

.menu-icon.open .menu-icon-bar:nth-child(3) {
    transform: translateY(-9.5px) rotate(-45deg);
}

/* Media Queries */

@media (max-width: 599px) {
    .menu-icon {
        display: flex;
    }
    
    .navbar-menu {
        position: absolute;
        top: 60px;
        left: 0;
        flex-direction: column;
        width: 100%;
        background-color: #333;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.4s ease-in-out, opacity 0.3s ease-in-out;
        opacity: 0;
        z-index: 10;
    }
    
    .navbar-menu.active {
        max-height: 300px;
        opacity: 1;
    }
    
    .navbar-menu li {
        width: 100%;
        text-align: center;
        transform: translateY(-10px);
        opacity: 0;
        transition: all 0.3s ease-in-out;
    }
    
    .navbar-menu.active li {
        transform: translateY(0);
        opacity: 1;
    }
    
    .navbar-menu.active li:nth-child(1) {
        transition-delay: 0.1s;
    }
    
    .navbar-menu.active li:nth-child(2) {
        transition-delay: 0.2s;
    }
    
    .navbar-menu.active li:nth-child(3) {
        transition-delay: 0.3s;
    }
    
    .navbar-menu.active li:nth-child(4) {
        transition-delay: 0.4s;
    }
    
    .navbar-item {
        display: block;
        padding: 1rem;
    }
}

@media (min-width: 600px) and (max-width: 767px) {
    .menu-icon {
        display: flex;
    }
    
    .navbar-menu {
        position: absolute;
        top: 60px;
        left: 0;
        flex-direction: column;
        width: 100%;
        background-color: #333;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.4s ease-in-out, opacity 0.3s ease-in-out;
        opacity: 0;
        z-index: 10;
    }
    
    .navbar-menu.active {
        max-height: 300px;
        opacity: 1;
    }
    
    .navbar-menu li {
        width: 100%;
        text-align: center;
        transform: translateY(-10px);
        opacity: 0;
        transition: all 0.3s ease-in-out;
    }
    
    .navbar-menu.active li {
        transform: translateY(0);
        opacity: 1;
    }
    
    .navbar-menu.active li:nth-child(1) {
        transition-delay: 0.1s;
    }
    
    .navbar-menu.active li:nth-child(2) {
        transition-delay: 0.2s;
    }
    
    .navbar-menu.active li:nth-child(3) {
        transition-delay: 0.3s;
    }
    
    .navbar-menu.active li:nth-child(4) {
        transition-delay: 0.4s;
    }
    
    .navbar-item {
        display: block;
        padding: 1rem;
    }
}

@media (min-width: 768px) and (max-width: 1023px) {
    .navbar-container {
        padding: 0 2rem;
    }
}

@media (min-width: 1024px) and (max-width: 1279px) {
    .navbar-container {
        padding: 0 3rem;
    }
}

@media (min-width: 1280px) and (max-width: 1439px) {
    .navbar-container {
        padding: 0 4rem;
    }
}

@media (min-width: 1440px) and (max-width: 1535px) {
    .navbar-container {
        padding: 0 5rem;
    }
}

@media (min-width: 1536px) and (max-width: 1919px) {
    .navbar-container {
        padding: 0 6rem;
        max-width: 1400px;
    }
}

@media (min-width: 1920px) and (max-width: 2559px) {
    .navbar-container {
        padding: 0 8rem;
        max-width: 1800px;
    }
}

@media (min-width: 2560px) {
    .navbar-container {
        padding: 0 10rem;
        max-width: 2200px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Navbar.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,gDAAgD;AACpD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,UAAU;IACV,6BAA6B;IAC7B,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,4CAA4C;AAChD;;AAEA,kBAAkB;;AAElB;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,sBAAsB;QACtB,WAAW;QACX,sBAAsB;QACtB,0CAA0C;QAC1C,aAAa;QACb,gBAAgB;QAChB,iEAAiE;QACjE,UAAU;QACV,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,4BAA4B;QAC5B,UAAU;QACV,gCAAgC;IACpC;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,sBAAsB;QACtB,WAAW;QACX,sBAAsB;QACtB,0CAA0C;QAC1C,aAAa;QACb,gBAAgB;QAChB,iEAAiE;QACjE,UAAU;QACV,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,UAAU;IACd;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,4BAA4B;QAC5B,UAAU;QACV,gCAAgC;IACpC;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,iBAAiB;IACrB;AACJ","sourcesContent":[".navbar {\n    background-color: #333;\n    padding: 1rem 0;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.navbar-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 1rem;\n}\n\n.navbar-logo {\n    color: #fff;\n    font-size: 1.5rem;\n    text-decoration: none;\n    font-weight: bold;\n    font-family: \"Rigidica Text Bold\", sans-serif;\n}\n\n.navbar-menu {\n    display: flex;\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n}\n\n.navbar-item {\n    color: #fff;\n    text-decoration: none;\n    padding: 0.5rem 1rem;\n    font-family: \"Rigidica Text Regular\", sans-serif;\n}\n\n.navbar-item:hover {\n    background-color: #444;\n}\n\n.navbar-backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.7);\n    opacity: 0;\n    transition: opacity 0.3s ease;\n    z-index: 5;\n    pointer-events: none;\n}\n\n.navbar-backdrop.active {\n    opacity: 1;\n    pointer-events: auto;\n}\n\n.menu-icon {\n    cursor: pointer;\n    display: none;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 30px;\n    height: 21px;\n    position: relative;\n    transition: all 0.3s ease-in-out;\n}\n\n.menu-icon-bar {\n    height: 2px;\n    width: 100%;\n    background-color: #fff;\n    border-radius: 2px;\n    transition: all 0.3s ease-in-out;\n    transform-origin: center;\n}\n\n.menu-icon.open .menu-icon-bar:nth-child(1) {\n    transform: translateY(9.5px) rotate(45deg);\n}\n\n.menu-icon.open .menu-icon-bar:nth-child(2) {\n    opacity: 0;\n    transform: scaleX(0);\n}\n\n.menu-icon.open .menu-icon-bar:nth-child(3) {\n    transform: translateY(-9.5px) rotate(-45deg);\n}\n\n/* Media Queries */\n\n@media (max-width: 599px) {\n    .menu-icon {\n        display: flex;\n    }\n    \n    .navbar-menu {\n        position: absolute;\n        top: 60px;\n        left: 0;\n        flex-direction: column;\n        width: 100%;\n        background-color: #333;\n        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n        max-height: 0;\n        overflow: hidden;\n        transition: max-height 0.4s ease-in-out, opacity 0.3s ease-in-out;\n        opacity: 0;\n        z-index: 10;\n    }\n    \n    .navbar-menu.active {\n        max-height: 300px;\n        opacity: 1;\n    }\n    \n    .navbar-menu li {\n        width: 100%;\n        text-align: center;\n        transform: translateY(-10px);\n        opacity: 0;\n        transition: all 0.3s ease-in-out;\n    }\n    \n    .navbar-menu.active li {\n        transform: translateY(0);\n        opacity: 1;\n    }\n    \n    .navbar-menu.active li:nth-child(1) {\n        transition-delay: 0.1s;\n    }\n    \n    .navbar-menu.active li:nth-child(2) {\n        transition-delay: 0.2s;\n    }\n    \n    .navbar-menu.active li:nth-child(3) {\n        transition-delay: 0.3s;\n    }\n    \n    .navbar-menu.active li:nth-child(4) {\n        transition-delay: 0.4s;\n    }\n    \n    .navbar-item {\n        display: block;\n        padding: 1rem;\n    }\n}\n\n@media (min-width: 600px) and (max-width: 767px) {\n    .menu-icon {\n        display: flex;\n    }\n    \n    .navbar-menu {\n        position: absolute;\n        top: 60px;\n        left: 0;\n        flex-direction: column;\n        width: 100%;\n        background-color: #333;\n        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);\n        max-height: 0;\n        overflow: hidden;\n        transition: max-height 0.4s ease-in-out, opacity 0.3s ease-in-out;\n        opacity: 0;\n        z-index: 10;\n    }\n    \n    .navbar-menu.active {\n        max-height: 300px;\n        opacity: 1;\n    }\n    \n    .navbar-menu li {\n        width: 100%;\n        text-align: center;\n        transform: translateY(-10px);\n        opacity: 0;\n        transition: all 0.3s ease-in-out;\n    }\n    \n    .navbar-menu.active li {\n        transform: translateY(0);\n        opacity: 1;\n    }\n    \n    .navbar-menu.active li:nth-child(1) {\n        transition-delay: 0.1s;\n    }\n    \n    .navbar-menu.active li:nth-child(2) {\n        transition-delay: 0.2s;\n    }\n    \n    .navbar-menu.active li:nth-child(3) {\n        transition-delay: 0.3s;\n    }\n    \n    .navbar-menu.active li:nth-child(4) {\n        transition-delay: 0.4s;\n    }\n    \n    .navbar-item {\n        display: block;\n        padding: 1rem;\n    }\n}\n\n@media (min-width: 768px) and (max-width: 1023px) {\n    .navbar-container {\n        padding: 0 2rem;\n    }\n}\n\n@media (min-width: 1024px) and (max-width: 1279px) {\n    .navbar-container {\n        padding: 0 3rem;\n    }\n}\n\n@media (min-width: 1280px) and (max-width: 1439px) {\n    .navbar-container {\n        padding: 0 4rem;\n    }\n}\n\n@media (min-width: 1440px) and (max-width: 1535px) {\n    .navbar-container {\n        padding: 0 5rem;\n    }\n}\n\n@media (min-width: 1536px) and (max-width: 1919px) {\n    .navbar-container {\n        padding: 0 6rem;\n        max-width: 1400px;\n    }\n}\n\n@media (min-width: 1920px) and (max-width: 2559px) {\n    .navbar-container {\n        padding: 0 8rem;\n        max-width: 1800px;\n    }\n}\n\n@media (min-width: 2560px) {\n    .navbar-container {\n        padding: 0 10rem;\n        max-width: 2200px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
